import type { UriType } from '~/model/GlobalTypes';
import { useLocale } from 'next-intl';
import { useEffect, useState } from 'react';
import { redirect, usePathname } from '@/i18n/routing';
import appConst, { CookieName } from '~/const/appConst';
import { removeCookie } from '~/utils/utils';
import { getErrorCodeFromUri } from '../utils/request/response';

export interface ApiError {
  '@id': UriType;
  'hydra:description': string;
  'hydra:title': string;
  error_description: string;
  message: string;
  code: number;
}

export function useError() {
  const pathname = usePathname();
  const locale = useLocale();

  const [error, setError] = useState<Partial<ApiError>>();

  const entityPathRegex = /^\/(interactions|projects)\/(\d+)$/;
  const messageGuard = pathname === appConst.staticRoutes.messages && !error?.['hydra:description'];

  const shouldNotRedirectOnBlocked = error?.['hydra:description'] === 'The account is blocked' || entityPathRegex.exec(pathname) || messageGuard;
  const status = getErrorCodeFromUri(error?.['@id']) || error?.code;

  useEffect(() => {
    if (!shouldNotRedirectOnBlocked && status === 403) {
      removeCookie(CookieName.ACCESS_TOKEN);
      removeCookie(CookieName.REFRESH_TOKEN);
      window.location.reload();
    }

    if (status === 503) {
      redirect({ href: appConst.staticRoutes.maintenance, locale });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return { error, status, setError };
}
